class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);

/* ---------- Inline upsell add-to-cart ---------- */

document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-upsell-add]');
  if (!btn) return;

  e.preventDefault();
  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.classList.add('is-loading');
  const spinner = btn.querySelector('.jc-cart-upsell__spinner');
  if (spinner) spinner.classList.remove('hidden');

  const body = JSON.stringify({
    items: [{ id: parseInt(variantId, 10), quantity: 1 }],
    sections: ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble']
  });

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: body
  })
  .then(r => r.json())
  .then(data => {
    if (data.sections) {
      Object.keys(data.sections).forEach(function(id) {
        const el = document.getElementById(id);
        if (el) {
          const parsed = new DOMParser().parseFromString(data.sections[id], 'text/html');
          const inner = parsed.querySelector('.shopify-section');
          if (inner) el.innerHTML = inner.innerHTML;
        }
      });
    } else {
      location.reload();
    }
  })
  .catch(function() {
    btn.classList.remove('is-loading');
    if (spinner) spinner.classList.add('hidden');
  });
});
